import { mergeDeepRight as merge } from 'ramda';

import actionTypes, { RESET_STORE_IMAGES } from '../actions/actionTypes';

const initialState = {
  uploadedImages: {},
  reasonImages: {},
  invoiceImages: {},
  storeImages: {},
  updatedProductIssue: {}
};

function orders(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_ORDER_DETAILS_DONE:
      return merge(state, { orderDetails: action.orderDetails });

    case actionTypes.GET_ORDER_PHONES_DONE:
      return merge(state, { orderPhones: action.orderPhones });

    case actionTypes.SAVE_PRODUCT_ISSUES_DONE:
      let updatedProductIssue = { ...state.updatedProductIssue };
      updatedProductIssue[action.productId] = action.updatedProductIssue;
      return merge(state, { updatedProductIssue, deletedProductId: null });

    case actionTypes.DELETE_PRODUCT_ISSUES_DONE:
      let deleteProductIssue = { ...state.updatedProductIssue };
      deleteProductIssue[action.productId] = action.updatedProductIssue;
      return merge(state, { updatedProductIssue: deleteProductIssue, deletedProductId: action.productId });

    case actionTypes.GET_ORDER_PRODUCTS_DONE:
      return merge(state, { orderProducts: action.orderProducts, updatedProductId: action.productId });

    case actionTypes.GET_ALL_ISSUE_REASONS_DONE:
      return merge(state, { reasons: action.reasons });

    case actionTypes.GET_DELIEVRY_ISSUE_REASONS_DONE:
      return merge(state, { deliveryReasons: action.deliveryReasons });

    case actionTypes.ORDER_DETAIL_IMAGES_DONE:
      let images = [];
      if (state.uploadedImages[action.id]) {
        images = [...state.uploadedImages[action.id]]
      } else {

      }

      if (action.images.length == 1) {
        images.push(action.images[0])
      } else {
        for (let i = 0; i < action.images.length; i++) {
          images.push(action.images[i])
        }
      }

      return merge(state, {
        uploadedImages: {
          [action.id]: images
        }
      });

    case actionTypes.ORDER_RESAON_DETAIL_IMAGES_DONE:
      let reasonImages = [];
      if (state.reasonImages[action.id]) {
        reasonImages = [...state.reasonImages[action.id]]
      }


      if (action.images.length == 1) {
        reasonImages.push(action.images[0])
      } else {
        for (let i = 0; i < action.images.length; i++) {
          reasonImages.push(action.images[i])
        }
      }

      return merge(state, {
        reasonImages: {
          [action.id]: reasonImages
        }
      });

    case actionTypes.INVOICE_IMAGES_DONE:
      let invoiceImages = [];
      if (state.invoiceImages[action.id]) {
        invoiceImages = [...state.invoiceImages[action.id]]
      } 


      if (action.images.length == 1) {
        invoiceImages.push(action.images[0])
      } else {
        for (let i = 0; i < action.images.length; i++) {
          invoiceImages.push(action.images[i])
        }
      }

      return merge(state, {
        invoiceImages: {
          [action.id]: invoiceImages
        }
      });

    case actionTypes.STORE_IMAGES_DONE:
      let storeImages = [];
      if (state.storeImages[action.id]) {
        storeImages = [...state.storeImages[action.id]]
      }

      if (action.images.length == 1) {
        storeImages.push(action.images[0])
      } else {
        for (let i = 0; i < action.images.length; i++) {
          storeImages.push(action.images[i])
        }
      }

      return merge(state, {
        storeImages: {
          [action.id]: storeImages
        }
      });

    case RESET_STORE_IMAGES:
      return {...state, [action.imageType]: {}}

    case actionTypes.GET_ORDERS_DONE:
      let result = action.orders;

      let createdOrders = { ...state };
      createdOrders.orders = result;
      return { ...createdOrders };

    case actionTypes.REMOVE_DETAIL_IMAGES_DONE:
      let uploadedImages = { ...state.uploadedImages };
      uploadedImages[action.id] = action.images;
      return merge(state, { uploadedImages });

    case actionTypes.RESET_ORDER_DETAIL_IMAGES_DONE:
      let resetKeys = { ...state };
      resetKeys.uploadedImages = {};
      resetKeys.reasonImages = {}
      return resetKeys;

    case actionTypes.ADD_REMARKS_DONE:
      let orderDetails = { ...state };
      orderDetails.orderDetails.remarks.push({
        message: action.remark.remark,
        userType: action.remark.remarkBy,
      })
      return merge(state, { orderDetails });

    case actionTypes.REMOVE_DETAIL_IMAGES_ORDER_DONE:

      let uploadedImagesTemp = { ...state };
      delete uploadedImagesTemp.uploadedImages[action.id]

      return uploadedImagesTemp;

    default:
      return state;
  }
};

export default orders;
